module.exports = __webpack_public_path__ + "static/media/Limiares.36a7887a.svg";